<h3>
  Flexibler Zuschlag
  <button class="btn btn-link" title="Flexiblen Zuschlag hinzufügen" (click)="openCreateModal()">
    <i class="fa fa-plus green"></i>
  </button>
</h3>
